import React, { useMemo } from 'react';
import { getMediaClient } from './getMediaClient';
export var MediaClientContext = /*#__PURE__*/React.createContext(undefined);
/** @deprecated Use MediaProvider instead */
export var MediaClientProvider = function MediaClientProvider(_ref) {
  var children = _ref.children,
    clientConfig = _ref.clientConfig;
  var mediaClient = useMemo(function () {
    return getMediaClient(clientConfig);
  }, [clientConfig]);
  return /*#__PURE__*/React.createElement(MediaClientContext.Provider, {
    value: mediaClient
  }, children);
};